import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '30',
  height: '32',
  viewBox: '-1 -1 32 34'
}, [
  h('path', {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: '#8091A5',
    d: 'M1.2 16.5c.2-.6.4-1.8.9-2.8C4.6 8.5 8.6 4.8 13.7 2.5c1-.5 2.2-.6 3.3-.6 1.4 0 2.3.9 2.4 2.4.1.7.1 1.5-.2 2.2-2.4 6.6-7.1 11-13.7 13.6-.2.1-.6.2-.8.2-2.1.3-3.5-1-3.5-3.8m17.1-5c3.5-.2 7.2-.6 10.9-.8l-.6-.6c-3.2-2.5-6.5-5.1-9.7-7.8-.3-.2-.6-.6-.9-1.3h3.6c1.3 0 2.8-.2 4 .2 2.8.6 4.4 2.4 4.3 5.3-.1 2.8-.3 5.4-.6 8.2-.3 4.2-.6 8.3-.9 12.5-.1.7-.2 1.5-.2 2.3-1.5-1.3-2.9-2.7-4.4-3.9-.2-.2-.3-.4-.6-.6-1.7-1.1-2.4-2.8-2.8-4.8-.6-2.6-1.3-5.2-1.9-7.8-.1-.2-.1-.5-.2-.9m-13.5 16c.8-.2 1.5-.2 2.2-.3.2-.1.6-.4.6-.6.6-2 1.3-4.1 1.9-6.2.1-.4.2-.4.3-.8 3.8 1.2 7.5 2.4 11.4 3.6-2 2-4.1 3.7-6.5 5.3 4.3.3 8.5.6 12.7 1v.2c-.9.1-1.9.2-2.8.2-5.4.3-10.7.7-16.2 1-.9-.1-1.7 0-2.6 0-3.6-.1-5.7-2-5.7-5.7 0-2 .2-4.1.3-6.1 0-.2.2-.2.3-.5.2.2.5.2.6.5l3.2 7.6c.1.3.1.4.3.8'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/language-ruby.es6.js